import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyS, HeadlineL } from '@sorare/core/src/atoms/typography';
import { Dialog } from '@sorare/core/src/components/dialog';
import { glossary } from '@sorare/core/src/lib/glossary';

const Root = styled(Vertical).attrs({ gap: 2 })`
  padding: var(--triple-unit) var(--triple-unit) var(--double-unit);
`;
const CautionParagraph = styled(BodyS).attrs({
  as: 'p',
  color: 'var(--c-nd-700)',
})`
  align-self: flex-start;
`;
const ButtonsWrapper = styled(Horizontal).attrs({ gap: 1.5 })`
  & > * {
    flex: 1;
  }
`;

type Props = {
  onClose: () => void;
  onContinue: () => void;
};
export const ExpertModeWarningDialog = ({ onClose, onContinue }: Props) => {
  return (
    <Dialog
      open
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      hideHeader
      footer={
        <ButtonsWrapper>
          <Button size="medium" color="primary" onClick={onClose}>
            <FormattedMessage {...glossary.cancel} />
          </Button>
          <Button size="medium" color="quaternary" onClick={onContinue}>
            <FormattedMessage {...glossary.continue} />
          </Button>
        </ButtonsWrapper>
      }
    >
      <Root>
        <FontAwesomeIcon icon={faTriangleExclamation} fontSize="24px" />
        <Vertical center>
          <HeadlineL>
            <FormattedMessage {...glossary.caution} />
          </HeadlineL>
        </Vertical>
        <CautionParagraph>
          <FormattedMessage
            id="ExpertModeWarningDialog.warningParagraph"
            defaultMessage="This option disables gameplay and marketplace tutorials. It's intended for Managers already familiar with how the game works. {br} Are you sure you want to continue?"
            values={{
              br: (
                <>
                  <br />
                  <br />
                </>
              ),
            }}
          />
        </CautionParagraph>
      </Root>
    </Dialog>
  );
};
